import React, { useEffect } from 'react';
import { useSearchParams, useParams } from 'react-router-dom';

const AutoLogin = () => {
  const [searchParams] = useSearchParams();
  const { tenantCode } = useParams();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      // Store token - same as TenantLogin.js
      localStorage.setItem('token', token);
      
      // Store tenant_code - critical for tenant dashboard routing
      if (tenantCode) {
        localStorage.setItem('tenant_code', tenantCode);
      }
      
      // Decode token to get user info
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const user = {
          id: payload.sub,
          email: payload.email,
          full_name: payload.full_name,
          role: payload.role,
          roles: payload.roles || [payload.role],
          tenant_id: payload.tenant_id
        };
        localStorage.setItem('user', JSON.stringify(user));
      } catch (e) {
        console.error('Token decode error:', e);
      }
      
      // Small delay to ensure localStorage writes are flushed before redirect
      setTimeout(() => {
        if (tenantCode) {
          window.location.replace(`/${tenantCode}/dashboard`);
        } else {
          window.location.replace('/dashboard');
        }
      }, 100);
    } else {
      window.location.replace(tenantCode ? `/${tenantCode}/login` : '/login');
    }
  }, [searchParams, tenantCode]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Entering college dashboard...</p>
      </div>
    </div>
  );
};

export default AutoLogin;
